import {
    Alert,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {useState} from 'react';
import SelectBank from '../../../components/SelectBank';
import PersonForm from './PersonForm';

export default ({handleChange, setFieldValue, values, errors}) => {
    const [value, setValue] = useState('1');

    const handleTabs = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <TabContext value={value}>
            <TabList onChange={handleTabs}>
                <Tab label="Dados pessoais" value="1" />
                <Tab label="Dados fiscais" value="2" />

                {/* <Tab label="Endereço" value="2" /> */}
            </TabList>
            <TabPanel value="1">
                <Grid container spacing={2}>
                    {Boolean(values.verified_at) && (
                        <Grid item xs={12}>
                            <Alert>
                                Dados verificados em {new Date(values.verified_at).toLocaleString()}
                            </Alert>
                        </Grid>
                    )}
                    <PersonForm data={values} />
                    {/* <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.name}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.name}
                            fullWidth
                            name="name"
                            label="Nome do profissional"
                            error={Boolean(errors.name)}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.professional_number}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.professional_number}
                            fullWidth
                            name="professional_number"
                            error={Boolean(errors.professional_number)}
                            label="Registro Profissional"
                            InputProps={{maxLength: 14}}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.phone}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.phone}
                            fullWidth
                            name="phone"
                            label="Telefone (DDD + Telefone)"
                            InputProps={{maxLength: 11}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.email}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.email}
                            error={Boolean(errors.email)}
                            fullWidth
                            name="email"
                            type="email"
                            label="E-mail"
                            InputProps={{maxLength: 11}}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <FormControl fullWidth error={Boolean(errors.document_type)}>
                            <InputLabel id="demo-simple-select-label">Tipo do documento</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="document_type"
                                value={values.document_type}
                                label="Tipo do documento"
                                onChange={handleChange}>
                                <MenuItem value="CPF">CPF</MenuItem>
                                <MenuItem value="CNPJ">CNPJ</MenuItem>
                            </Select>
                            <FormHelperText error={Boolean(errors.document_type)}>
                                {errors.document_type}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.document}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.document}
                            fullWidth
                            name="document"
                            error={Boolean(errors.document)}
                            label="Documento (CPF ou CPNJ)"
                            InputProps={{maxLength: 14}}
                        />
                    </Grid>*/}
                </Grid> 
            </TabPanel>
            <TabPanel value="3">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.zipcode}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.zipcode}
                            fullWidth
                            name="zipcode"
                            label="CEP"
                            InputProps={{maxLength: 7}}
                        />
                        {Boolean(values.address) && (
                            <FormHelperText>
                                {values.address}, {values.city}-{values.state}
                            </FormHelperText>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.number}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.number}
                            fullWidth
                            name="number"
                            label="Número"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.complement}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.complement}
                            fullWidth
                            name="complement"
                            label="Complemento"
                        />
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value="2">
                <Grid container rowGap={2} columnSpacing={2}>
                    {Boolean(values.approved_at) && (
                        <Grid item xs={12}>
                            <Alert>
                                Dados aprovados em {new Date(values.approved_at).toLocaleString()}
                            </Alert>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="document-type-label">Tipo do documento</InputLabel>
                            <Select
                                labelId="document-type-label"
                                id="document-type"
                                value={values.business_document_type}
                                label="Tipo do documento"
                                name="business_document_type"
                                disabled={values.approved}
                                error={Boolean(errors.business_document_type)}
                                helperText={errors.business_document_type}
                                onChange={handleChange}>
                                <MenuItem value="CPF">CPF</MenuItem>
                                <MenuItem value="CNPJ">CNPJ</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Documento (CPF ou CNPJ)"
                            type="text"
                            name="business_document_number"
                            onChange={handleChange}
                            value={values.business_document_number}
                            disabled={values.approved_at}
                            error={Boolean(errors.business_document_number)}
                            helperText={errors.business_document_number}
                            InputProps={{
                                maxLenght: 14,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Razão Social ou Fantasia"
                            type="text"
                            name="business_name"
                            onChange={handleChange}
                            value={values.business_name}
                            disabled={values.approved_at}
                            error={Boolean(errors.business_name)}
                            helperText={errors.business_name}
                            InputProps={{
                                maxLenght: 14,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="WalletID Asaas"
                            type="text"
                            name="walletAsaasId"
                            onChange={handleChange}
                            value={values.walletAsaasId}
                            disabled={values.approved_at}
                            error={Boolean(errors.walletAsaasId)}
                            helperText={errors.walletAsaasId}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <SelectBank
                            name="bank_number"
                            value={values.bank_number}
                            onChange={setFieldValue}
                            error={Boolean(errors.bank_number)}
                            helperText={errors.bank_number}
                        />
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Agencia"
                            type="text"
                            name="bank_agency"
                            onChange={handleChange}
                            value={values.bank_agency}
                            error={Boolean(errors.bank_agency)}
                            helperText={errors.bank_agency}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Digito"
                            type="text"
                            name="bank_agency_digit"
                            onChange={handleChange}
                            value={values.bank_agency_digit}
                            error={Boolean(errors.bank_agency_digit)}
                            helperText={errors.bank_agency_digit}
                        />
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Conta"
                            type="text"
                            name="bank_account"
                            onChange={handleChange}
                            value={values.bank_account}
                            error={Boolean(errors.bank_account)}
                            helperText={errors.bank_account}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Digito"
                            type="text"
                            name="bank_account_digit"
                            onChange={handleChange}
                            value={values.bank_account_digit}
                            error={Boolean(errors.bank_account_digit)}
                            helperText={errors.bank_account_digit}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <FormControl fullWidth>
                            <InputLabel id="account-type-label">Tipo da conta</InputLabel>
                            <Select
                                labelId="account-type-label"
                                id="account-type"
                                value={values.bank_account_type}
                                error={Boolean(errors.bank_account_type)}
                                helperText={errors.bank_account_type}
                                label="Tipo da conta"
                                name="bank_account_type"
                                onChange={handleChange}>
                                <MenuItem value="checking">Corrente</MenuItem>
                                <MenuItem value="saves">Poupança</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </TabPanel>
        </TabContext>
    );
};
